import React from 'react'
import Header from './pages/Header';

const App = () => {
  return (
    <Header/>
  )
}

export default App;